@if (!displayPupilList) {
  <app-student-exclusion
    [pupilData]="selectedPupil"
    [isCreateExclusion]="isCreateExclusion"
    (goBacktoViewPupilList)="displaypupilList()"
    [schoolId]="schoolId"
    [schoolName]="schoolName"
  ></app-student-exclusion>
}
@if (displayPupilList) {
  <div>
    <div class="grid align-center vertical-container">
      <div class="col-12">
        <div class="brand-bar"></div>
        <div class="box">
          <app-school-list
            [headerText]="headerText"
            (schoolChanged)="schoolChange($event)"
          ></app-school-list>
        </div>
      </div>
    </div>
    <br />
    <div class="grid">
      <div class="col">
        <div class="float-left">
          <label class="text-bold">Search by name or UPN</label><br />
          <input
            [disabled]="isLoading"
            type="text"
            [(ngModel)]="searchByUPNOrName"
            pInputText
            placeholder="Search by name or UPN"
            class="p-inputtext-searchfield"
            (keydown.enter)="searchText()"
            #inputSearchByUPNorName
          />
          <button
            [disabled]="isLoading"
            title="Search"
            label="Search"
            pButton
            class="button-custom"
            (click)="searchText()"
          ></button>
        </div>
        <div class="float-right">
          <div class="float-left fields-separation">
            <label class="text-bold" id="lblShow">Show</label>
            <div class="width-tweleve">
              <p-select
                [disabled]="isLoading"
                [options]="showExclusionOptions"
                id="selectlist"
                (onChange)="changeExclusionOptions($event)"
                [(ngModel)]="selectedExclusionOptions"
                ariaLabelledBy="lblShow"
                #showDropDown
              ></p-select>
            </div>
          </div>
          <div class="float-right whitespace">
            <label class="text-bold" id="lblSortby">Sort by</label>
            <div class="width-twentyone">
              <p-select
                [disabled]="isLoading"
                [options]="showSortOptions"
                id="sortList"
                (onChange)="changeSortyByOptions($event)"
                [(ngModel)]="selectedSortByOptions"
                ariaLabelledBy="lblSortby"
                #sortOptionsDropDown
              ></p-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p-table
      #allPupilList
      class="checkboxSelectionTable"
      [value]="pupils"
      [rows]="50"
      [rowsPerPageOptions]="[50, 100, 150]"
      [paginator]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [showCurrentPageReport]="true"
      selectionMode="single"
      (onRowSelect)="onRowSelect($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="align-left width-fifteen">Name</th>
          <th class="width-ten">UPN</th>
          <th class="width-fifteen number-header-right-align">Year Group</th>
          <th class="width-ten number-header-right-align">
            Days Excl. this Term
          </th>
          <th class="width-twenty">Last Excl. Date</th>
          <th class="width-fifteen">Last Excl. Category</th>
          <th class="width-fifteen" [ariaHidden]="true"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-pupils>
        <tr [pSelectableRow]="pupils">
          @if (!noPupilFoundMessage) {}
          <td class="overflow-wrap">
            <a href="#" (click)="redirectToStudSummaryPage(pupils)">{{
              pupils.studentName
            }}</a>
          </td>
          <td class="overflow-wrap">{{ pupils.upn }}</td>
          <td class="number-right-align">{{ pupils.ncy }}</td>
          <td class="number-right-align">
            {{ pupils.excludedDaysInCurrentTerm }}
          </td>
          <td>{{ pupils.lastExclusionDate | date: "dd/MM/yyyy" }}</td>
          <td class="overflow-wrap">{{ pupils.lastExclusionCategory }}</td>
          <td>
            @if (!pupils.isOffRoll && !isPermOrAperExclusionExist(pupils)) {
              <button
                title="Add Exclusion"
                label="Add"
                pButton
                (click)="redirectToCreateExclusion(pupils)"
                class="button-custom-color float-right button-zoom-support"
              ></button>
            }
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        @if (noPupilFoundMessage) {
          <tr>
            <td [attr.colspan]="7">No pupils found</td>
          </tr>
        }
      </ng-template>
    </p-table>
  </div>
}
<p-confirmDialog icon="pi pi-exclamation-triangle"></p-confirmDialog>
